import axios from "../axiosInstance"
import { formatarDataRequisicao } from "../shared/utils/Formatacao"
import {
    lotesAmostras,
    lotes,
    tiposLote,
    statusLote,
    lotesExcluirAmostra,
    obterLote,
    obterImagemAssinaturaLote,
    obterImagemBiopsiaLote,
    editarLote,
    listarAmostrasLote,
    listarEventosLote,
    gerarEtiquetaImpressaoLote,
    possuiTipoConservacaoLote,
    planilhaLotes,
    gerarManifestoCarga,
    gerarReciboRecolhimento,
    exportarDadosLote
} from "../shared/utils/Endpoints"
import qs from "qs"
import { converterArquivoStreamParaBlob } from "../shared/utils/ArquivoUtil";

class LotesService {
    async listarLotes(operacoesListagem, uuid) {
        const filtros = operacoesListagem.filtros;
        const paginacao = operacoesListagem.paginacao;
        const ordenacao = operacoesListagem.ordenacao;

        return await axios.get(lotes, {
            params: {
                Termo: filtros && filtros.busca,
                TiposLote: filtros && filtros.tipos && filtros.tipos.map(tipo => tipo.codigo),
                StatusLote: filtros && filtros.status && filtros.status.map(status => status.codigo),
                DataInicioPeriodo: filtros && formatarDataRequisicao(filtros.dataInicio),
                DataFinalPeriodo: filtros && formatarDataRequisicao(filtros.dataFinal),
                Pagina: paginacao && paginacao.pagina,
                ItensPorPagina: paginacao && paginacao.itensPagina,
                ColunaOrdenacao: ordenacao && ordenacao.coluna,
                OrdenacaoDecrescente: ordenacao && ordenacao.decrescente,
                UUID: uuid
            },
            paramsSerializer: (params) => {
                return qs.stringify(params)
            }
        })
    }

    async baixarPlanilha(operacoesListagem) {
        const filtros = operacoesListagem.filtros;
        const ordenacao = operacoesListagem.ordenacao;

        return await axios.get(planilhaLotes, {
            params: {
                Termo: filtros && filtros.busca,
                TiposLote: filtros && filtros.tipos && filtros.tipos.map(tipo => tipo.codigo),
                StatusLote: filtros && filtros.status && filtros.status.map(status => status.codigo),
                DataInicioPeriodo: filtros && formatarDataRequisicao(filtros.dataInicio),
                DataFinalPeriodo: filtros && formatarDataRequisicao(filtros.dataFinal),
                ColunaOrdenacao: ordenacao && ordenacao.coluna,
                OrdenacaoDecrescente: ordenacao && ordenacao.decrescente,
            },
            paramsSerializer: (params) => {
                return qs.stringify(params)
            },
            responseType: "arraybuffer"
        }).then((res) => {
            if (res?.data) {
                return converterArquivoStreamParaBlob(res.data);
            }
        });
    }

    async listarTiposLote(exibirTiposOcultos) {
        return await axios.get(tiposLote, {
            params: { ExibirTiposOcultos: exibirTiposOcultos }
        }, { cache: true })
    }

    async listarStatusLote() {
        return await axios.get(statusLote, { cache: true })
    }

    async inserirAmostraLote(dados, retornarErro, loteKPA) {
        return await axios.patch(lotesAmostras, {
            IdLote: Number(dados.idLote),
            IdAmostra: Number(dados.idAmostra),
            CodigoAmostra: dados.codigoAmostra,
            loteKPA: loteKPA
        }, {
            returnResponseOnError: retornarErro,
        });
    }

    async listarEventosLote(idLote) {
        return await axios.get(listarEventosLote.replace(/{idLote}/, idLote));
    }

    async listarAmostrasLote(idLote) {
        return await axios.get(listarAmostrasLote.replace(/{idLote}/, idLote));
    }

    async exportarDadosLote(idLote) {
        return await axios.get(exportarDadosLote.replace(/{idLote}/, idLote), {
            responseType: 'arraybuffer',
        }).then((res) => {
            if (res?.data) {
                return converterArquivoStreamParaBlob(res.data);
            }
        });
    }

    async gerarEtiquetaImpressao(idLote) {
        return await axios.get(gerarEtiquetaImpressaoLote.replace(/{idLote}/, idLote));
    }

    async possuiTipoConservacao(idLote) {
        return await axios.get(possuiTipoConservacaoLote.replace(/{idLote}/, idLote));
    }

    async salvarTipoConservacao(idLote, idTipoConservacao) {
        return await axios.post('/lotes/salvartipoconservacao', {
			idLote: idLote,
			idTipoConservacao: idTipoConservacao,
		});
	}

    async excluirAmostraLote(dados, retornarErro) {
        return await axios.delete(
            lotesExcluirAmostra
                .replace(/{idLote}/, dados.idLote)
                .replace(/{idAmostra}/, dados.idAmostra)
                .replace(/{codigoAmostra}/, dados.codigoAmostra), {
            returnResponseOnError: retornarErro,
        });
    }

    async cadastrarLote(dados) {
        return await axios.post(lotes, {
            Codigo: dados.codigo ? Number(dados.codigo) : null,
            TipoLote: {
                id: Number(dados.tipoLote.id),
                codigo: Number(dados.tipoLote.codigo)
            },
            TipoConservacao: {
                id: Number(dados.tipoConservacao.id),
                codigo: dados.tipoConservacao.codigo
            },
            Temperatura: dados.temperatura,
            Empresa: dados.empresa
        });
    }

    async editarLote(dados) {
        return await axios.patch(editarLote.replace(/{idLote}/, dados.id), {
            TipoLote: {
                id: Number(dados.tipoLote.id),
                codigo: Number(dados.tipoLote.codigo)
            },
            TipoConservacao: {
                id: Number(dados.tipoConservacao.id),
                codigo: dados.tipoConservacao.codigo
            },
            Temperatura: dados.temperatura,
            empresa: dados.empresa
        });
    }

    async obterDadosLote(idLote) {
        return await axios.get(obterLote.replace(/{idLote}/, idLote))
    }

    async obterImagemBiopsiaLote(idLote) {
        return await axios.get(obterImagemBiopsiaLote.replace(/{idLote}/, idLote))
    }

    async obterImagemAssinaturaLote(idLote) {
        return await axios.get(obterImagemAssinaturaLote.replace(/{idLote}/, idLote))
    }

    async obterManifestoCarga(idsLotes) {
        return await axios.get(gerarManifestoCarga, {
            params: {
                idsLote: idsLotes
            },
            paramsSerializer: (params) => {
                return qs.stringify(params)
            },
            responseType: "blob"
        });
    }

    async obterReciboRecolhimento(idLote) {
        return await axios.get(gerarReciboRecolhimento, {
            params: {
                idLote: idLote
            },
            paramsSerializer: (params) => {
                return qs.stringify(params)
            },
            responseType: "blob"
        });
    }
}

export default new LotesService()